export enum ValidationErrorCode {
    ERROR = 'ERROR',
    REQUIRED = 'REQUIRED',
    TOO_MANY_ATTACHMENTS = 'TOO_MANY_ATTACHMENTS',
}
